import { useListState } from "@mantine/hooks";
import { ClientInferResponseBody } from "@ts-rest/core";
import { useEffect } from "react";

import { contract } from "#app/http/api";
import { QuoteRequestLinesSimilarPartDto } from "#modules/similarPart/infra/searchQuoteRequestLineSimilarParts.api";

type TargetDto = NonNullable<
  ClientInferResponseBody<typeof contract.quoteRequestLines.findOne>["cluster"]
>["targetQuoteRequestLines"][number];

export const useClusterToggleSelect = (
  cluster: TargetDto[],
  setCluster: (cluster: TargetDto[]) => void,
): {
  isSelected: (similarPart: QuoteRequestLinesSimilarPartDto) => boolean;
  handleToggleSelect: (similarPart: QuoteRequestLinesSimilarPartDto) => void;
} => {
  const [clusterState, { append, remove }] = useListState(cluster);

  useEffect(() => {
    setCluster(clusterState);
  }, [setCluster, clusterState]);

  const isSelected = (similarPart: QuoteRequestLinesSimilarPartDto | undefined) => {
    if (!similarPart) {
      return false;
    }

    return cluster.some(
      (selectedQuoteRequestLine: TargetDto) => selectedQuoteRequestLine.id === similarPart.id,
    );
  };

  const handleToggleSelect = (similarPart: QuoteRequestLinesSimilarPartDto) => {
    if (isSelected(similarPart)) {
      remove(cluster.findIndex((c: TargetDto) => c.id === similarPart.id));
    } else {
      append(similarPart);
    }
  };

  return {
    isSelected,
    handleToggleSelect,
  };
};
